



























import Vue from "vue";

export default Vue.extend({
  name: "BaseInputColor",
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewType: {
      type: String,
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$refs.input.click();
      }
    },
    updateSelf(value: string) {
      this.$emit("input", value);
    },
  },
});
